var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayButtonTriangle = function SvgPlayButtonTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9v6.914c0 1.566 1.719 2.525 3.051 1.702l11.194-6.914a2 2 0 0 0 0-3.404L3.051.384C1.719-.439 0 .52 0 2.086V9Z",
    fill: "#FFFDFC"
  })));
};
export default SvgPlayButtonTriangle;